<mat-card>
    <mat-card-header>
        <mat-card-title>ABOUT US</mat-card-title>
        <mat-card-subtitle>Last updated November 17, 2023</mat-card-subtitle>
    </mat-card-header>

<mat-card-content>
    <h3>About <strong>Yard Hostle</strong></h3>
    <p>Welcome to <strong>Yard Hostle</strong>! 
    <p>Manage your yard and trailers with our applications. Stay in control in real-time, sync data seamlessly across devices, and receive insightful reports via email. Streamline your operations and boost productivity with our intuitive inventory management solution.</p>

    <h3>Products and Services</h3>
    <p>Our primary focus revolves around software, especially Software as a Service (SaaS) and applications. We are dedicated to offering innovative technological solutions that simplify lives and augment productivity.</p>

</mat-card-content>
</mat-card>